import React, {  Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useInvAF, useInvMain } from "../../../St/Reviews/UseStyle";
import { Container, Divider} from "@material-ui/core";
import { txtA } from "../../../Label/Lbl";
import moment from "moment";
import { useBody, useHeader } from "./style";

function Header(props) {
  const { locInv, sta, info, num } = props;
  const clasm = useInvMain();
  const clas = useInvAF();
  const calssBody = useBody();
  const classHeader = useHeader();
  const secondColor = "#be151f";
  const styf = { fontWeight: "1200" };
  const stysub = { fontWeight: "bold", color: secondColor };
  const styfC = { fontWeight: "500" };
  return (
    <Fragment>
      {num == 2 ?
        (
          <Grid
            item
            container
            style={{
              paddingTop: "0.1rem", fontWeight: "bold",
            }}
          >
            <Grid item xs={5} className={classHeader.leftHeaderen}>
              <div style={styf}>{info.Disc1_header_en}</div>
              <div style={stysub}>{info.Disc2_header_en}</div>
              <div style={styfC}>{info.Disc3_header_en}</div>{" "}
              <div style={styfC}>{info.Disc4_header_en}</div>
              <div style={styf}>{"Vat number " + info.tax_no}</div>
            </Grid>

            <Grid item xs={2} className={clasm.mincntr}>
              <div>
                <ButtonBase>
                  {" "}
                  <img
                    src={`data:image/jpeg;base64,${info.Logo}`}
                    className={clas.Hedlogo}
                    alt={info.nameA}
                  />{" "}
                </ButtonBase>
              </div>
            </Grid>

            <Grid item xs={5} className={classHeader.rightHeaderar}>
              <div style={styf}>{info.Disc1_header_ar}</div>{" "}
              <div style={stysub}>{info.Disc2_header_ar}</div>{" "}
              <div style={styfC}>{info.Disc3_header_ar}</div>{" "}
              <div style={styfC}>{info.Disc4_header_ar}</div>{" "}
              <div style={styf}>{"الرقم الضريبي " + info.tax_no}</div>
            </Grid>
          </Grid>)

        : info.header_img != null ?
          (<Grid item xs={12} justifyContent="center" style={{ minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
            <div>
              <ButtonBase>
                {" "}
                <img
                  src={`data:image/jpeg;base64,${info.header_img}`}
                  className={clas.headerImg}
                  alt={info.nameA}
                />{" "}
              </ButtonBase>
            </div>
          </Grid>) :
          (
            <Grid
              item
              container
              style={{
                paddingTop: "0.1rem", fontWeight: "bold",
              }}
            >
              <Grid item xs={5} className={classHeader.leftHeaderen}>
                <div style={styf}>{info.Disc1_header_en}</div>
                <div style={stysub}>{info.Disc2_header_en}</div>
                <div style={styfC}>{info.Disc3_header_en}</div>{" "}
                <div style={styfC}>{info.Disc4_header_en}</div>
                <div style={styf}>{"Vat number " + info.tax_no}</div>
              </Grid>

              <Grid item xs={2} className={clasm.mincntr}>
                <div>
                  <ButtonBase>
                    {" "}
                    <img
                      src={`data:image/jpeg;base64,${info.Logo}`}
                      className={clas.Hedlogo}
                      alt={info.nameA}
                    />{" "}
                  </ButtonBase>
                </div>
              </Grid>

              <Grid item xs={5} className={classHeader.rightHeaderar}>
                <div style={styf}>{info.Disc1_header_ar}</div>{" "}
                <div style={stysub}>{info.Disc2_header_ar}</div>{" "}
                <div style={styfC}>{info.Disc3_header_ar}</div>{" "}
                <div style={styfC}>{info.Disc4_header_ar}</div>{" "}
                <div style={styf}>{"الرقم الضريبي " + info.tax_no}</div>
              </Grid>
            </Grid>)}

      <Container>
        <Divider style={{ background: secondColor, height: 1.5 }} />
        <Grid style={{ paddingTop: "0.1cm" }}>
          <Divider
            style={{ background: secondColor, height: 1.5 }}
          />
        </Grid>

      </Container>
      <Container>
        <Grid
          container
          item
          xs={12}
          style={{ direction: "rtl", paddingTop: "0.2rem" }}
        >
          <Grid xs={3} item container style={{ paddingTop: 10 }}>
            <Grid item xs={6} className={calssBody.txt}>
              التاريخ
            </Grid>
            <Grid item xs={6}>
              <Typography className={calssBody.minclr}>
                {moment(sta?.tot?.date).format("YYYY/MM/DD")}
              </Typography>
            </Grid>
            {num !== 7 && (
              <Grid item xs={6} className={calssBody.txt}>
                اجمالي الكمية{" "}
              </Grid>

            )}
            {num !== 7 && (
              <Grid item xs={6}>
                <Typography className={calssBody.minclr}>
                  {sta?.info?.reduce(
                    (sum, item) => Number(sum) + Number(item.val1),
                    0
                  )}
                </Typography>
              </Grid>
            )}

          </Grid>
          <Grid xs={6} item>
            {locInv.ProcTypeInvProc != "03" && (
              <Typography
                className={calssBody.minclr}
                variant="h5"
                gutterBottom
              >
                {/* {info.nameA} */}
                {sta?.tot?.tax_no_cust === ""
                  ? "فاتورة ضريبية مبسطة"
                  : "فاتورة ضريبية"}
              </Typography>
            )}
            <Typography className={calssBody.minclr} variant="h6" gutterBottom>
              {locInv.invN + " "}
            </Typography>
          </Grid>
          <Grid
            xs={3}
            item
            container
            style={{
              paddingTop: 5,
              paddingLeft: 5,
              direction: "ltr",
              color: secondColor,
            }}
          >
            <Grid item xs={6}>
              <Typography
                className={calssBody.txt}
                style={{ fontWeight: "bold" }}
              >
                Inv No
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className={calssBody.minclr}>
                {sta?.tot?.id}
              </Typography>
            </Grid>
            <Grid item xs={6} className={calssBody.txt}>
              Ref No
            </Grid>
            <Grid item xs={6}>
              <Typography className={calssBody.minclr} >
                {sta?.tot?.refno}
              </Typography>
            </Grid>
          </Grid>

          <Grid item container style={{ paddingTop: "0.4rem" }}>
            <Grid
              item
              xs={10}
              className={calssBody.txt}
              container
              style={{ fontWeight: "bold" }}
            >
              <Grid item xs={2}>
                {txtA.custmName + "/ "}
              </Grid>
              <Grid item xs={10}>
                {sta?.tot?.cust_name}
                {sta?.tot?.cust_address?.length > 2
                  ? "  -  " + sta?.tot?.cust_address
                  : ""}
              </Grid>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid
              item
              xs={10}
              container
              className={calssBody.txt}
              style={{ fontWeight: "bold", paddingTop: 5 }}
            >
              <Grid item xs={2}>
                {txtA.taxNumr + "/ "}
              </Grid>
              <Grid item xs={10}>
                {sta?.tot?.tax_no_cust}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
}
export default Header;
